import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListProposals from '../../proposal/list-proposals';
import Header from '../../common/components/header';
import Sidebar from '../../common/components/sidebar';

const ProposalRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/" element={<ListProposals />} />
          </Routes>
        </div>
      </div>

      <>Some Footer Stuff</>
    </>
  );
};

export default ProposalRoutes; 